import { HomeSummaryEntity } from "../entities/HomeSummaryEntity";
import { HomeRepository } from "../repositories/HomeRepository";

/**
 * Loads everything the Home page renders in a single call.
 */
export class GetHomeSummaryUseCase {
  constructor(private readonly repository: HomeRepository) {}

  execute(signal?: AbortSignal): Promise<HomeSummaryEntity> {
    return this.repository.getSummary(signal);
  }
}
